export const LOCALES = ['de', 'en'];
export const DEFAULT_LOCALE = 'de';
export const COOKIE_NAME = 'NEXT_LOCALE';
export const STORAGE_KEY = 'preferred_locale';

export const LOCALE_META = {
    de: {
        code: 'de',
        label: 'Deutsch',
        htmlLang: 'de',
        flag: '/images/flags/de.svg',
        switchLabel: 'Switch to English',
    },
    en: {
        code: 'en',
        label: 'English',
        htmlLang: 'en',
        flag: '/images/flags/gb.svg',
        switchLabel: 'Zu Deutsch wechseln',
    },
};

export function isValidLocale(locale) {
    return LOCALES.includes(locale);
}

export function negotiateLocale(acceptLanguage) {
    if (!acceptLanguage) return DEFAULT_LOCALE;
    const candidates = acceptLanguage
        .split(',')
        .map((part) => part.trim().split(';')[0].toLowerCase().split('-')[0]);
    return candidates.find((c) => LOCALES.includes(c)) ?? DEFAULT_LOCALE;
}
